import { Link } from "react-router-dom";

export default function AIBalance() {
  return (
    <section
      data-stage="3c"
      className="relative py-32 md:py-48 px-6 md:px-12 overflow-hidden"
    >
      <div className="relative max-w-3xl mx-auto">
        <article data-reveal className="group">
          <div className="aspect-[16/9] w-full rounded-2xl overflow-hidden border border-line mb-8">
            <img
              src="https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/869afa14-5463-471e-8bee-55af117645e8_compressed_blumen_gehirn.webp"
              alt="KI und Mensch"
              title="KI & Mensch - Vocatur"
              className="w-full h-full object-cover object-center group-hover:scale-[1.03] transition-transform duration-700"
            />
          </div>

          <div className="flex items-center gap-3 text-xs text-inkDim mb-4">
            <span className="uppercase tracking-[0.2em] text-moss">KI &amp; Mensch</span>
            <span className="w-1 h-1 rounded-full bg-inkDim/40" />
            <span>Lesedauer: 1 Minute</span>
          </div>

          <h2 className="font-display text-3xl md:text-4xl text-ink leading-snug mb-6">
            Nicht jede Antwort muss menschlich sein.
          </h2>

          <p className="font-display italic text-xl md:text-2xl text-sage leading-snug mb-8">
            Aber jede wichtige Frage verdient einen Menschen.
          </p>

          <div className="space-y-5 text-sm md:text-base text-inkDim leading-relaxed">
            <p>
              Deshalb verbinden wir in vielen Projekten das Beste aus beiden Welten:
              <strong className="font-medium text-ink"> KI übernimmt Routinen, Menschen übernehmen Verantwortung.</strong>
            </p>
            <p>
              Genauso wichtig ist uns jedoch, junge Menschen auf diese neue Realität vorzubereiten.
              Als Fördermitglied von <a href="https://www.wissenschaft-spass.de/" target="_blank" rel="noopener noreferrer nofollow" className="font-medium text-ink underline underline-offset-2 hover:text-moss transition-colors">WISSENschaf(f)t SPASS</a> unterstützen wir
              Initiativen des <a href="https://www.deutsches-museum.de/bonn" target="_blank" rel="noopener noreferrer nofollow" className="font-medium text-ink underline underline-offset-2 hover:text-moss transition-colors">Deutschen Museums Bonn</a>, die Kindern und Jugendlichen einen spielerischen und
              neugierigen Zugang zu Künstlicher Intelligenz ermöglichen.
            </p>
          </div>

          <div className="mt-12">
            <span aria-hidden="true" className="mb-6 block h-px w-16 bg-sage/50" />
            <p className="font-display italic text-xl md:text-2xl text-sage leading-snug">
              Denn die Zukunft gehört nicht der KI.
            </p>
            <p className="mt-2 font-display italic text-xl md:text-2xl text-sage leading-snug">
              Sondern den Menschen, die gelernt haben, mit ihr umzugehen.
            </p>
          </div>

          <div className="mt-8 rounded-2xl border border-sage/25 bg-bgSoft/70 p-5 transition-colors hover:border-sage/50 md:mt-10 md:p-6">
            <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
              <div>
                <span className="text-[10px] uppercase tracking-[0.3em] text-moss">
                  KI &amp; Mensch · Das ganze Kapitel
                </span>
                <p className="mt-2 font-display text-lg text-ink md:text-xl">
                  Kunde und KI alleine?
                </p>
                <p className="mt-1 text-xs leading-relaxed text-inkDim md:text-sm">
                  Vom Frosch, dem Skorpion und der Frage, wer am Ende sticht
                  oder besticht. Ein paar Stichworte dazu …
                </p>
              </div>
              <Link
                to="/ki"
                className="inline-flex shrink-0 items-center gap-2 self-start rounded-[var(--btn-radius)] bg-sage px-6 py-3 text-sm font-medium text-bg transition-colors hover:bg-ink md:self-auto whitespace-nowrap"
              >
                Weiterlesen
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}